import SiteHeader from "../modules/site-header";
import SiteNavMobile from "../modules/site-nav-mobile";

export default () => {
    const nodeSelectors = {
        container: '[js-mega-menu="container"]',
        opener: '.mega-menu-opener',
        tabOpener: '[js-mega-menu="tab-opener"]',
        tab: '[js-mega-menu="tab"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        jQuery(nodeSelectors.container).each(function () {
            let container = jQuery(this)
            let tabOpener = container.find(nodeSelectors.tabOpener)
            let tab = container.find(nodeSelectors.tab)

            tabOpener.on('click', function (e) {
                tabOpener.removeClass('item--active')
                jQuery(this).addClass('item--active')

                let targetedTab = jQuery(this).data('js-mega-menu--tab-opener-target')

                tab.removeClass('tab--active')
                container.find(targetedTab).addClass('tab--active')

                if( jQuery(window).width() < 1024 ) {
                    setTimeout(function() {
                        let scrollTopTarget = jQuery(SiteNavMobile().nodeSelectors.container).scrollTop() + container.find(targetedTab).position().top - SiteHeader().getHeight() - 20
                        jQuery(SiteNavMobile().nodeSelectors.container).animate({ scrollTop: scrollTopTarget }, 200);
                    }, 50)
                }
            })
        })
    }

    return Object.freeze({
        init,
    })
}